import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {AbstractControl, FormControl} from "@angular/forms";
import {isEmpty, xor} from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {OrderStatus} from "../../models/order";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-order-status-selector]',
  templateUrl: './order-status-selector.component.html',
  styleUrls: ['./order-status-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderStatusSelectorComponent implements OnInit {
  @Input() public control?: AbstractControl | null;
  public statuses: string[];
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private ref: ChangeDetectorRef) {
    this.statuses = Object.values(OrderStatus)
      .filter((i: string | number) => typeof i === 'string' && i !== 'None' && i !== 'Preliminary' && i !== 'Canceled')
      .map(i => i == OrderStatus[OrderStatus.PartiallyReleased] ? 'Partially Released' : i)
      .map(i => i.toString().toUpperCase());
    this.selectionChange = this.selectionChange.bind(this);
  }

  public ngOnInit(): void {
    this.control?.setValue([OrderStatus[OrderStatus.Pending].toUpperCase()]);
  }

  public selectionChange(selection: string[]) {
    this.control?.setValue(selection);
    this.ref.detectChanges();
  }

  public ngAfterViewInit(): void {
    this.control?.valueChanges.pipe(takeUntil(this.onDestroy$))
      .subscribe(value => this.ref.detectChanges())
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
